<div class="relative h-full">
  <button
    class="bg-[#F5B2A8] px-6 w-96 flex justify-between items-center cursor-pointer relative h-full"
    [ngClass]="{ '!bg-white border border-borderColor': isOpen() }"
    (click)="toggle()"
    aria-haspopup="true"
    [attr.aria-expanded]="isOpen()"
  >
    <div class="flex">
      @if (userInitials() && !isB2B()) {
        <div
          class="h-11 w-11 rounded-full bg-white overflow-hidden mr-2.5 flex items-center justify-center text-lg font-semibold border border-borderColor"
        >
          {{ userInitials().replaceAll('.', '') }}
        </div>
      }
      @if (isB2B()) {
        <div
          class="h-11 w-11 rounded-full bg-white overflow-hidden mr-2.5 flex items-center justify-center border border-borderColor"
        >
          <sc-svg name="profile-avatar" size="w-11 h-11"></sc-svg>
        </div>
      }
      @if (user()) {
        <div class="flex flex-col justify-center">
          @if (userNameDetails() && !isB2B()) {
            <div
              [title]="fullName()"
              class="text-left text-base w-[255px] overflow-hidden whitespace-nowrap fade-effect"
            >
              {{ userNameDetails().firstName }} {{ userNameDetails().prefix }}
              {{ userNameDetails().lastName }}
            </div>
          }

          @if (isOpen()) {
            <div
              class="relative font-semibold cursor-pointer flex items-center"
              scClickToCopy="{{ user().email }}"
            >
              <div
                [title]="user().email"
                class="font-bold text-sm text-left w-[255px] overflow-hidden whitespace-nowrap fade-effect"
              >
                {{ user().email }}
              </div>
            </div>
          } @else {
            <div
              [title]="user().email"
              class="font-bold text-sm text-left w-[255px] overflow-hidden whitespace-nowrap fade-effect"
            >
              {{ user().email }}
            </div>
          }
        </div>
      }
    </div>
    <sc-svg
      name="arrow-down"
      size="w-5 h-5"
      class="transform"
      [class.rotate-180]="isOpen()"
    ></sc-svg>
  </button>
  @if (isOpen()) {
    <div
      aria-hidden="true"
      class="fixed left-0 right-0 bottom-0 top-[150px] bg-[#3D3333CC]"
      (click)="close()"
    ></div>
    <div
      class="absolute bg-white top-[100%] right-0 w-full rounded-b-xl"
      [formGroup]="form"
      style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)"
    >
      <div class="flex items-center justify-between p-6 pb-3">
        <p class="font-headline text-desktopH3">
          {{ productConfig().title | scTranslate | async }}
        </p>
        <sc-svg [name]="productConfig().headerIcon" class="h-10.5 w-10.5"></sc-svg>
      </div>
      <div #scrollContainer class="px-6 overflow-y-auto max-h-[228px]">
        <sc-msisdn-radio-button-list (msisdnSelected)="close()"></sc-msisdn-radio-button-list>
      </div>

      <div class="p-6 pt-3">
        <sc-button variant="alternate" [url]="mainUrl" class="h-10.5 flex items-center gap-x-1">
          <span>{{ 'shared.addSim' | scTranslate | async }}</span>
          <sc-svg name="plus"></sc-svg>
        </sc-button>
      </div>

      @if (isProductSwitchAvailable()) {
        <div class="px-6 py-4 w-full border-t border-borderColor">
          <sc-button
            variant="text"
            class="flex justify-between w-full"
            (click)="setActiveProduct(productConfig().switchProduct)"
          >
            <div class="flex justify-between items-center w-full">
              <div class="flex items-center gap-x-3">
                <sc-svg [name]="productConfig().switchIcon" class="h-[21px] w-[21px]"></sc-svg>
                <span>{{ productConfig().switchText | scTranslate | async }}</span>
              </div>
              <sc-svg name="arrow-right"></sc-svg>
            </div>
          </sc-button>
        </div>
      }

      <div class="p-6 border-y border-borderColor" [formGroup]="form">
        <div class="font-semibold mb-1">
          {{ 'shared.language' | scTranslate | async }}
        </div>
        <sc-select formControlName="languageCode" (outSelectedOption)="outSelectedOption($event)">
          @for (locale of localeList$ | async; track locale.code; let index = $index) {
            <sc-option
              [option]="{
                id: locale.code,
                label: locale.name | scRemoveTermShorthand,
              }"
              [ngClass]="{ hidden: locale.code === selectedLanguage() }"
            >
              {{ locale.name }}
            </sc-option>
          }
        </sc-select>
      </div>

      <div class="p-6 flex flex-col gap-y-3">
        <sc-button variant="primary" class="h-10.5" (clicked)="signout()">
          <span>{{ 'shared.signOut' | scTranslate | async }}</span>
          <sc-svg name="signout"></sc-svg>
        </sc-button>
        @if (!isLimited()) {
          <sc-button variant="text" class="h-10.5 flex items-center" (click)="goToSettings()">
            <span>{{ 'shared.goToSettings' | scTranslate | async }}</span>
            <sc-svg name="arrow-right"></sc-svg>
          </sc-button>
        }
      </div>
    </div>
  }
</div>
